import React from 'react';
import { makeStyles } from 'design-system/styles';
import classNames from 'classnames';

interface NERTextLineProps {
  tokenIdx: number;
  text: string;
  textClassName: string;
  maxDepth: number;
  maxLinkDepth: number;
  disableSelection?: boolean;
  textDirection?: 'rtl' | 'ltr';
}

const getPaddingTop = (maxLinkDepth: number) => {
  if (maxLinkDepth === 0) {
    return 10;
  } else {
    return 12 + 16 * maxLinkDepth;
  }
};

const getPaddingBottom = (maxDepth: number) => {
  if (maxDepth === 1) {
    return 20;
  } else {
    return Math.max(10, 3 * (maxDepth + 1));
  }
};

const NERTextLine: React.ForwardRefRenderFunction<HTMLDivElement, NERTextLineProps> = (
  { tokenIdx, text, textClassName, maxDepth, maxLinkDepth, disableSelection, textDirection },
  forwardRef,
) => {
  const classes = useNERTextLineStyles();
  return (
    <div
      className={classNames(classes.line, textClassName, {
        [classes.lineSelectionDisabled]: disableSelection,
      })}
      ref={forwardRef}
      data-token-idx={tokenIdx}
      style={{
        paddingTop: getPaddingTop(maxLinkDepth),
        paddingBottom: getPaddingBottom(maxDepth),
        textAlign: textDirection === 'rtl' ? 'right' : 'left',
      }}
    >
      {text}
    </div>
  );
};

const useNERTextLineStyles = makeStyles({
  line: {
    position: 'relative',
    color: 'black !important',
    zIndex: 1,
    '&::selection': {
      background: 'transparent !important',
      color: 'inherit',
    },
  },

  lineSelectionDisabled: {
    userSelect: 'none',
  },
});

export default React.forwardRef(NERTextLine);
